import { useDispatch, useSelector } from "react-redux";
import ActivityCard from "../components/ActivityCard";
import PageContainer from "../components/PageContainer";
import { getUserActivities } from "../redux/userActivitiesSlice";
import { useCallback, useEffect, useState } from "react";
import { useRefreshHandler } from "../components/pullToRefresh/useRefreshHandler";
import { Link } from "react-router-dom";
import { setScroll } from "../redux/scrollSlice";
import PageSwitcher from "../components/PageSwitcher";
import CardContainer from "../components/CardContainer";
import Pool from "../components/poolBar/Pool";
import error404 from '../static/images/404.jpg';
import { useTranslation } from "react-i18next";
import { resetBacklink } from "../redux/backlinkSlice";
import { Helmet } from 'react-helmet-async';

const AllActivities = () => {
    const { t, i18n } = useTranslation();

    const { error, data, pageSize, page, totalPages, activitiesAmount } = useSelector(state => state.userActivities)

    const filters = useSelector(state => state.filters);

    // Imposto AllActivities per la Pool e imposto backlink in home (in modo da non renderizzare il tasto back)
    const dispatch = useDispatch();

    // Chiamo le activities coi filtri impostati
    // SearchBar e compagnia modificano sempre il filters (memorizzato in filtersSlice) ed è il suo cambiamento che fa ripartire ogni volta la fetch che aggiorna la pagina

    // QUESTO È LO USEEFFECT CHE ESEGUE LA CHIAMATA getUserActivities ALL'ATTERRAGGIO IN PAGINE
    // ED OGNI VOLTA CHE FILTERS CAMBIA (la page è sempre risettata su 1)
    // getUserActivities NON viene eseguito quando l'utente torna da una pagina dettaglio
    const { link } = useSelector(state => state.backlink);
    useEffect(() => {
        // Impedisco la chiamata se l'utente torna da una pagina dettaglio
        if (link === "/activity-details") {
            dispatch(resetBacklink());
            return;
        }
        dispatch(getUserActivities({ filters, pageSize, page: 1, lang: i18n.language }))
        window.scrollTo({top: 0, behavior: 'smooth'});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, filters, i18n.language])

    // Pull-to-refresh (nativo): ricarica la lista con i filtri correnti dalla prima pagina (thunk → spinner fino al termine).
    useRefreshHandler(useCallback(
        () => dispatch(getUserActivities({ filters, pageSize, page: 1, lang: i18n.language })),
        [dispatch, filters, pageSize, i18n.language]
    ));

    // Gestisco l'apertura della modale
    const [isFiltersModalOpen] = useState();
    useEffect(() => {
        isFiltersModalOpen ? dispatch(setScroll(false)) : dispatch(setScroll(true))
    }, [dispatch, isFiltersModalOpen])

    // Gestisco il click su una nuova pagina all'interno del componente PageSwitcher
    const handlePageClick = (page) => {
        // Scrollo al top della pagina
        window.scrollTo(0, 0);
        dispatch(getUserActivities({ filters, pageSize, page, lang: i18n.language }));
    }

    return (

        <PageContainer items="center">
            <Helmet>
                <title>Tutte le attività - TicinoWild</title>
                <meta name="description" content="Esplora tutte le attività outdoor in Ticino: trekking, sport acquatici, esperienze in quota e tante idee per il tempo libero. Filtra per tipo, regione e difficoltà." />
                <link rel="canonical" href="https://ticinowild.ch/all-activities" />
                <meta property="og:title" content="Tutte le attività - TicinoWild" />
                <meta property="og:description" content="Esplora tutte le attività outdoor in Ticino: trekking, sport acquatici, esperienze in quota e tante idee per il tempo libero. Filtra per tipo, regione e difficoltà." />
                <meta property="og:url" content="https://ticinowild.ch/all-activities" />
                <meta name="twitter:title" content="Tutte le attività - TicinoWild" />
                <meta name="twitter:description" content="Esplora tutte le attività outdoor in Ticino: trekking, sport acquatici, esperienze in quota e tante idee per il tempo libero. Filtra per tipo, regione e difficoltà." />
            </Helmet>

            <Pool />

            {
                !error && data &&
                <div className="w-full text-center my-2 md:my-8">
                    <div>
                        <h5><span className="text-[#225424]">{activitiesAmount}</span> {t('AllActivities.activitiesFound')}</h5>
                    </div>
                    <div className="w-full h-[2px] bg-neutral-300"></div>
                </div>
            }

            {/* MAP BUTTON */}
            <Link to="/map-page">
                <div className="flex gap-2 bg-[#225424] text-white py-2 px-4 rounded-xl cursor-pointer mt-2">
                    <i className="fi fi-rr-map mt-0.5"></i>
                    <div>{t('AllActivities.mapButton')}</div>
                </div>
            </Link>


            {/* Gestisco l'ordine di visualizzazione fra mappa e card container.
                w-full mobile: senza, la larghezza segue il contenuto delle card
                (vedi commento in CardContainer) */}
            <div className="w-full md:w-auto flex flex-col">
                {/* CARD CONTAINER */}
                <div className="w-full md:w-auto flex flex-col py-4">
                    {!error && data && <PageSwitcher currentPage={page} totalPages={totalPages} activitiesAmount={activitiesAmount} handlePageClick={handlePageClick} />}
                    <CardContainer>
                        {
                            !error && data && data.length > 0 && data.map((element, index) => {
                                return <ActivityCard key={index} activityData={element} />
                            })
                        }
                    </CardContainer>
                    {
                        /* 404 nessun elemento trovato */
                        data && data.length === 0 &&
                        <div className="mx-16 flex flex-col xl:flex-row gap-8 justify-center items-center">
                            {/* Copy */}
                            <div className="flex flex-col items-center gap-4 text-center">
                                {/* <h3>Errore 404, nessun elemento trovato</h3> */}
                                <div className="text-8xl text-[#225424] font-signature mb-6">{t('AllActivities.comingSoonTitle')}</div>
                                <div className="text-[#b05704] text-xl">{t('AllActivities.comingSoonSubtitle')}</div>
                            </div>

                            {/* Foto */}
                            <div className="rounded-xl overflow-hidden">
                                <img src={error404} alt="404" className="md:max-w-[800px]" />
                            </div>
                        </div>

                    }
                    {!error && data && <PageSwitcher currentPage={page} totalPages={totalPages} activitiesAmount={activitiesAmount} handlePageClick={handlePageClick} />}
                </div>
            </div>
            {
                error && error.message === "Nessuna attività trovata" &&
                <h3 className="text-[#225424]">{t('AllActivities.noDataFoundError')}</h3>
            }

        </PageContainer>
    )
}

export default AllActivities;